export default "__VITE_ASSET__7272138d__"